export const adminAppMeta = {
  name: 'Retro Arcade Admin',
  milestone: 'M5',
  purpose: 'Owner catalog metadata, compatibility validation and controlled publication workflow',
} as const;
